import { component } from "picoapp";
import { klaviyoSubscribe } from "@root/tablescape/utilities";

export default component((node) => {
  const form = node;
  const listId = form.getAttribute("data-list-id");

  form.addEventListener("submit", (e) => {
    e.preventDefault();

    const email = e.target.elements.email.value;

    if (!email) {
      return;
    }

    klaviyoSubscribe(listId, email, {
      customSource: "newsletter form",
    }).then((res) => {
      if (res?.ok) {
        form.classList.add("was-successful");
        form.reset();
      }

      setTimeout(() => {
        // form.classList.remove('was-successful')
      }, 2000);
    });
  });
});
